import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';

const _constants = {
  cornerRadius: 8,
  rightMargin: 68,
  topMargin: 40,
  bottomMargin: 40,
  progressBarBottomMargin: 10,
  dotWidth: 15,
  dotSpacing: 5,
  dotVerticalMargin: 3,
};

export class CmsDotBar extends Lightning.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      h: _constants.dotWidth + _constants.dotVerticalMargin * 2,
      ProgressBarBackground: {
        w: w => w,
        h: h => h,
        color: Theme.Colors.Banner.DotBar.background,
        alpha: 0.5,
        rect: true,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: _constants.dotWidth / 2,
        },
      },
      ProgressBarContainer: {
        w: w => w,
        h: h => h,
        color: Theme.Colors.Transparent,
        rect: true,
      },
    };
  }

  _init() {
    this.ProgressContainer = this.tag('ProgressBarContainer');
    this.ProgressBackground = this.tag('ProgressBarBackground');
  }

  set amount(amount) {
    this._amount = amount;
    for (let i = 0; i < amount; i++) {
      this.ProgressContainer.childList.a({
        w: _constants.dotWidth,
        h: _constants.dotWidth,
        x: _constants.dotSpacing * (i + 1) + _constants.dotWidth * i,
        y: h => h / 2,
        mountY: 0.5,
        color: Theme.Colors.Banner.DotBar.unselected,
        alpha: 0.5,
        rect: true,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: _constants.dotWidth / 2,
        },
      });
    }
    this.patch({
      w: _constants.dotWidth * amount + _constants.dotSpacing * (amount + 1),
    });
  }

  updateUI(oldIndex, newIndex) {
    this.ProgressContainer.childList._items[oldIndex].patch({
      color: Theme.Colors.Banner.DotBar.unselected,
      alpha: 0.5,
    });
    this.ProgressContainer.childList._items[newIndex].patch({
      color: Theme.Colors.Banner.DotBar.selected,
      alpha: 1,
    });
  }
}
